import EventService from '@/services/EventService.js'
//this ensures unique name for actions, getters, mutations,
//default is false
export const namespaced = true
export const state = {
  eventCount: 0,
  eventTest: { title: 'testing' },
  events: [],
  event: {},
  mailsettings: []
}

export const mutations = {
  ADD_EVENT(state, event) {
    state.events.push(event)
  },
  SET_EVENTS(state, events) {
    state.events = events
  },
  SET_EVENTCOUNT(state, count) {
    state.eventCount = count
  },
  SET_EVENT(state, event) {
    state.event = event
  },
  SET_MAILSETTINGS(state, mailsettings) {
    state.mailsettings = mailsettings
  }
}

export const actions = {
  createEvent({ commit, dispatch }, event) {
    //console.log(event)
    return EventService.postEvent(event)
      .then(() => {
        commit('ADD_EVENT', event)
        const notification = {
          type: 'success',
          message: 'Event Successfully Added: ' + event.id
        }
        dispatch('notification/add', notification, { root: true })
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'Problem with event: ' + event.id + ': ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  fetchEvents({ commit, rootState, dispatch }, { perPage, page }) {
    return EventService.getEvents(perPage, page)
      .then(response => {
        //Note: use rootstate to pass in global state to access
        //data from other modules (this comes from store.js)
        console.log('from another module: ' + rootState.user.user.name)
        console.log('total events: ' + response.headers['x-total-count'])
        commit('SET_EVENTS', response.data)
        commit('SET_EVENTCOUNT', response.headers['x-total-count'])
      })
      .catch(error => {
        console.log(error.message)
        const notification = {
          type: 'error',
          message: 'there was an error fetching events: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  } /*,
  fetchMailSettings({ commit, rootState, dispatch }) {
    EventService.getMailSettings()
      .then(response => {
        //Note: use rootstate to pass in global state to access
        //data from other modules (this comes from store.js)
        //console.log('from another module: ' + rootState.user.user.name)
        //console.log('total events: ' + response.headers['x-total-count'])
        commit('SET_MAILSETTINGS', response.data)
        //commit('SET_EVENTCOUNT', response.headers['x-total-count'])
      })
      .catch(error => {
        console.log(error.message)
        const notification = {
          type: 'error',
          message: 'there was an error fetching events: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  }*/,
  loadEvent({ commit, getters, dispatch }, value) {
    //This is good, use getters first then call api
    // changing it to test progress bars
    //var event = getters.getEventById(value)
    //if (event) {
    //  console.log('FROM GETTER')
    //  commit('SET_EVENT', event)
    //} else {
    //  console.log('calling API')
    return EventService.getEvent(value)
      .then(response => {
        commit('SET_EVENT', response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'there was an error fetching event: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
    //}
  }
}

export const getters = {
  getEventById: state => id => {
    //console.log(state)
    return state.events.find(event => event.id === id)
  }
}
